import { haptics } from './lib/haptics';
import { useFreshMoment } from './lib/experience';
import { t, tf } from './lib/i18n';

export const REACTIONS = ['😂', '😳', '🔥', '🤝'] as const;
export type ReactionSymbol = typeof REACTIONS[number];

interface ReceivedReaction { userId: string; firstName: string; reaction: string }

export function ReactionBar({ mine, received, disabled, onReact }: {
  mine?: { reaction: string };
  received: ReceivedReaction[];
  disabled: boolean;
  onReact: (reaction: ReactionSymbol) => void;
}) {
  const receivedKey = received.map((item) => `${item.userId}:${item.reaction}`).sort().join('|') || null;
  const freshReaction = useFreshMoment(receivedKey, haptics.reactionReceived);

  return <>
    <div className="reaction-row" role="group" aria-label={t('React to this reveal')}>
      {REACTIONS.map((reaction) => <button
        key={reaction}
        type="button"
        disabled={disabled || Boolean(mine)}
        className={mine?.reaction === reaction ? 'reaction selected' : 'reaction'}
        aria-label={tf('React {reaction}', { reaction })}
        aria-pressed={mine?.reaction === reaction}
        onClick={() => { haptics.reactionSent(); onReact(reaction); }}
      >{reaction}</button>)}
    </div>
    <div className={freshReaction ? 'reaction-notes fresh-social-moment' : 'reaction-notes'} aria-live="polite">
      {received.map((reaction) => <p className="reaction-note" key={reaction.userId}>
        <span className="reaction-origin" aria-hidden="true">{reaction.firstName.slice(0, 1).toUpperCase()}</span>
        <span><strong>{reaction.firstName}</strong> {tf('reacted {reaction}', { reaction: reaction.reaction })}</span>
      </p>)}
    </div>
  </>;
}
